import store from '@/store'
export const forLoop = async (range, request, type, query, storeId = null) => {
  try {
    let list = []
    for (let i = 0; i < range; i++) {
      query.page += 1
      let res
      if (storeId) {
        res = await request(type, query, store, storeId)
      } else {
        res = await request(type, query, store)
      }
      if (res && res.status === 200) {
        list = [...list, ...res.data.items]
      }
    }
    return list
  } catch (error) {
    return error
  }
}
export const loopRequests = async (array, request) => {
  try {
    let response = {}
    for (let i = 0; i < (array || []).length; i++) {
      const element = array[i]
      const res = await request(element)
      if (res && res.status === 200) {
        response = { ...response, [element]: res.data }
      }
    }
    return response
  } catch (error) {
    return error
  }
}
